import React from 'react';
import PropTypes from 'prop-types';
import {
    Row, Col, Form, InputNumber, Typography, Checkbox,
} from 'antd';
import './DetailsFields.scss';

const DetailsFields = (props) => {
    const {
        initialValuesObject, mode,
    } = props;

    const handleBrokenBoolean = (brokenValue) => {
        switch (true) {
            case brokenValue === 'true':
            case brokenValue === true:
                return true;

            case brokenValue === 'false':
            case brokenValue === false:
            default:
                return false;
        }
    };

    return (
        <>
            <Row
                gutter={[24, 24]}
                className="VantMapeamentoErvasInvasorasFields__CropHeightRow"
            >
                <Col
                    xs={{ span: 24 }}
                    className="VantMapeamentoErvasInvasorasFields__CropHeightColumn"
                >
                    <Form.Item
                        label={(
                            <Typography.Title
                                level={5}
                                className="VantMapeamentoErvasInvasorasFields__CropHeightTitle VantMapeamentoErvasInvasorasFields__AllFormLabels"
                            >
                                Inserir a altura da cultura (em m)
                            </Typography.Title>
                        )}
                        name="VANT-MAPEAMENTO_ERVAS-INVASORAS-INSERIR_ALTURA_CULTURA"
                        className="VantMapeamentoErvasInvasorasFields__CropHeightFormItem"
                        rules={[
                            {
                                required: true,
                                message: 'Por favor informe a altura da cultura em metros',
                            },
                        ]}
                        initialValue={initialValuesObject?.['VANT-MAPEAMENTO_ERVAS-INVASORAS-INSERIR_ALTURA_CULTURA']}
                    >
                        <InputNumber
                            className="VantMapeamentoErvasInvasorasFields__CropHeightInput"
                            min={0.00}
                            step={0.01}
                            decimalSeparator=","
                            disabled={mode === 'EDIT'}
                        />
                    </Form.Item>
                </Col>
            </Row>

            <Row
                gutter={[24, 24]}
                className="VantMapeamentoErvasInvasorasFields__PulverizationRow"
            >
                <Col
                    xs={{ span: 24 }}
                    className="VantMapeamentoErvasInvasorasFields__PulverizationColumn"
                >
                    <Form.Item
                        valuePropName="checked"
                        name="VANT-MAPEAMENTO_ERVAS-INVASORAS-PULVERIZACAO"
                        className="VantMapeamentoErvasInvasorasFields__PulverizationFormItem"
                        initialValue={handleBrokenBoolean(initialValuesObject?.['VANT-MAPEAMENTO_ERVAS-INVASORAS-PULVERIZACAO']) || false}
                    >
                        <Checkbox
                            className="VantMapeamentoErvasInvasorasFields__PulverizationCheckbox VantMapeamentoErvasInvasorasFields__AllFormLabels"
                            disabled={mode === 'EDIT'}
                        >
                            Pulverização
                        </Checkbox>
                    </Form.Item>
                </Col>
            </Row>

            <Row
                gutter={[24, 24]}
                className="VantMapeamentoErvasInvasorasFields__SubsoilingRow"
            >
                <Col
                    xs={{ span: 24 }}
                    className="VantMapeamentoErvasInvasorasFields__SubsoilingColumn"
                >
                    <Form.Item
                        valuePropName="checked"
                        name="VANT-MAPEAMENTO_ERVAS-INVASORAS-SUBSOLAGEM"
                        className="VantMapeamentoErvasInvasorasFields__SubsoilingFormItem"
                        initialValue={handleBrokenBoolean(initialValuesObject?.['VANT-MAPEAMENTO_ERVAS-INVASORAS-SUBSOLAGEM']) || false}
                    >
                        <Checkbox
                            className="VantMapeamentoErvasInvasorasFields__SubsoilingCheckbox VantMapeamentoErvasInvasorasFields__AllFormLabels"
                            disabled={mode === 'EDIT'}
                        >
                            Subsolagem
                        </Checkbox>
                    </Form.Item>
                </Col>
            </Row>

            <Row
                gutter={[24, 24]}
                className="VantMapeamentoErvasInvasorasFields__HarrowingRow"
            >
                <Col
                    xs={{ span: 24 }}
                    className="VantMapeamentoErvasInvasorasFields__HarrowingColumn"
                >
                    <Form.Item
                        valuePropName="checked"
                        name="VANT-MAPEAMENTO_ERVAS-INVASORAS-GRADAGEM"
                        className="VantMapeamentoErvasInvasorasFields__HarrowingFormItem"
                        initialValue={handleBrokenBoolean(initialValuesObject?.['VANT-MAPEAMENTO_ERVAS-INVASORAS-GRADAGEM']) || false}
                    >
                        <Checkbox
                            className="VantMapeamentoErvasInvasorasFields__HarrowingCheckbox VantMapeamentoErvasInvasorasFields__AllFormLabels"
                            disabled={mode === 'EDIT'}
                        >
                            Gradagem
                        </Checkbox>
                    </Form.Item>
                </Col>
            </Row>

            <Row
                gutter={[24, 24]}
                className="VantMapeamentoErvasInvasorasFields__SecondaryCultureRow"
            >
                <Col
                    xs={{ span: 24 }}
                    className="VantMapeamentoErvasInvasorasFields__SecondaryCultureColumn"
                >
                    <Form.Item
                        valuePropName="checked"
                        name="VANT-MAPEAMENTO_ERVAS-INVASORAS-CULTURA_SECUNDARIA"
                        className="VantMapeamentoErvasInvasorasFields__SecondaryCultureFormItem"
                        initialValue={handleBrokenBoolean(initialValuesObject?.['VANT-MAPEAMENTO_ERVAS-INVASORAS-CULTURA_SECUNDARIA']) || false}
                    >
                        <Checkbox
                            className="VantMapeamentoErvasInvasorasFields__SecondaryCultureCheckbox VantMapeamentoErvasInvasorasFields__AllFormLabels"
                            disabled={mode === 'EDIT'}
                        >
                            Cultura Secundária
                        </Checkbox>
                    </Form.Item>
                </Col>
            </Row>

            <Row
                gutter={[24, 24]}
                className="VantMapeamentoErvasInvasorasFields__TertiaryCultureRow"
            >
                <Col
                    xs={{ span: 24 }}
                    className="VantMapeamentoErvasInvasorasFields__TertiaryCultureColumn"
                >
                    <Form.Item
                        valuePropName="checked"
                        name="VANT-MAPEAMENTO_ERVAS-INVASORAS-CULTURA_TERCEARIA"
                        className="VantMapeamentoErvasInvasorasFields__TertiaryCultureFormItem"
                        initialValue={handleBrokenBoolean(initialValuesObject?.['VANT-MAPEAMENTO_ERVAS-INVASORAS-CULTURA_TERCEARIA']) || false}
                    >
                        <Checkbox
                            className="VantMapeamentoErvasInvasorasFields__TertiaryCultureCheckbox VantMapeamentoErvasInvasorasFields__AllFormLabels"
                            disabled={mode === 'EDIT'}
                        >
                            Cultura Terciária
                        </Checkbox>
                    </Form.Item>
                </Col>
            </Row>

            <Row
                gutter={[24, 24]}
                className="VantMapeamentoErvasInvasorasFields__PlantingManeuverAutomationRow"
            >
                <Col
                    xs={{ span: 24 }}
                    className="VantMapeamentoErvasInvasorasFields__PlantingManeuverAutomationColumn"
                >
                    <Form.Item
                        valuePropName="checked"
                        name="VANT-MAPEAMENTO_ERVAS-INVASORAS-AUTOMATIZACAO_MANOBRA_PLANTIO"
                        className="VantMapeamentoErvasInvasorasFields__PlantingManeuverAutomationFormItem"
                        initialValue={handleBrokenBoolean(initialValuesObject?.['VANT-MAPEAMENTO_ERVAS-INVASORAS-AUTOMATIZACAO_MANOBRA_PLANTIO']) || false}
                    >
                        <Checkbox
                            className="VantMapeamentoErvasInvasorasFields__PlantingManeuverAutomationCheckbox VantMapeamentoErvasInvasorasFields__AllFormLabels"
                            disabled={mode === 'EDIT'}
                        >
                            Automatização de Manobra de Plantio (cereais)
                        </Checkbox>
                    </Form.Item>
                </Col>
            </Row>
        </>
    );
};

DetailsFields.propTypes = {
    formInstance: PropTypes.shape({
        getFieldValue: PropTypes.func.isRequired,
        validateFields: PropTypes.func.isRequired,
    }).isRequired,

    initialValuesObject: PropTypes.shape({
        'VANT-MAPEAMENTO_ERVAS-INVASORAS-INSERIR_ALTURA_CULTURA': PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        'VANT-MAPEAMENTO_ERVAS-INVASORAS-PULVERIZACAO': PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
        'VANT-MAPEAMENTO_ERVAS-INVASORAS-SUBSOLAGEM': PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
        'VANT-MAPEAMENTO_ERVAS-INVASORAS-GRADAGEM': PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
        'VANT-MAPEAMENTO_ERVAS-INVASORAS-CULTURA_SECUNDARIA': PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
        'VANT-MAPEAMENTO_ERVAS-INVASORAS-CULTURA_TERCEARIA': PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
        'VANT-MAPEAMENTO_ERVAS-INVASORAS-AUTOMATIZACAO_MANOBRA_PLANTIO': PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    }).isRequired,

    mode: PropTypes.oneOf(['CREATE', 'EDIT']).isRequired,
};
DetailsFields.defaultProps = {};

export default DetailsFields;
